 <div class="light-bg">


   <div class="content-wrapper">
     <p class="hint">{{'TWO_FA_TEXT' | dictionary : email}}</p>

       <input [(ngModel)]="code2fa" class="code-field"
              aria-describedby="emailHelp"/>

     <div class="checkbox-wrapper">
       <input id="remember2fa" class="checkbox-field" type="checkbox"
              [(ngModel)]="remember2fa"/>
       <label for="remember2fa">{{'TWO_FA_REMEMBER_LABEL' | dictionary}}</label>
     </div>

       <div class="bottom-block">


         <div class="left-block">
           <div>{{'CODE_WAITING_TIME' | dictionary}}</div>
           <div>{{'HAVE_NOT_RECEIVED' | dictionary}} <button (click)="resendCode()" [disabled]="secondCount">{{'RESEND_CODE' | dictionary}}<span *ngIf="secondCount"> in {{secondCount}} seconds</span></button></div>
         </div>

         <div class="actions">
           <button (click)="submit()" class=" button-1 text-color-1">
             {{'SUBMIT' | dictionary}}
           </button>
           <button (click)="cancel()" class="button-1 text-color-1">
             {{'CANCEL' | dictionary}}
           </button>
         </div>
        </div>





 <!--  <div class="col-sm-12"> -->

 <!--      <div class="col-sm-12" style="height: 5px;"></div> -->
 <!--    </div> -->
 <!--  </div> -->
 <!--  <div> -->
 <!--  </div> -->
   <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
   </app-pop-up-dialog>
 </div>



